module.exports = __webpack_public_path__ + "static/media/cm3.13d77968.png";